import { type LayoutContainerWidth } from 'noddi-ui-web';
import { type PropsWithChildren, useState } from 'react';
import { type PageBackground, PageLayoutContext } from './PageLayoutContext';

export const PageLayoutProvider = ({ children }: PropsWithChildren) => {
  const [width, setWidth] = useState<LayoutContainerWidth | undefined>(undefined);
  const [background, setBackground] = useState<PageBackground | undefined>(undefined);
  return (
    <PageLayoutContext.Provider value={{ width, setWidth, background, setBackground }}>
      {children}
    </PageLayoutContext.Provider>
  );
};
